import React from "react";
import { useForm } from "react-hook-form";
import { debounce } from "lodash";
import { connect } from "react-redux";
import toast from "react-hot-toast";
import InputFloatingStyle from "../../../../sass/floatingLabel.scss";

const CompteEntityForm = ({ entity, updateStructureInfo }) => {
   const {
      register,
      handleSubmit,
      formState: { errors },
   } = useForm({
      mode: "onChange",
      defaultValues: {},
   });

   const submitAfterDebounce = (e) => {
      let submitBtn = document.querySelector("#ue_entity_form_hidden_submit");
      submitBtn.click();
   };

   const handleUpdateEntity = async (data) => {
      const args = data;
      args.id = entity.id;

      try {
         const result = await axios.put("/Api/user/entity", args);
         updateStructureInfo(data);
         result.data ? toast.success("Actualisation de vos données de structure réussie", { id: "structure" }) : null;
      } catch (err) {
         console.log(err);
         toast.error("Un problème est survenu lors de l`'actualisation de vos données");
      }
   };

   return (
      <div className={"form w-100"}>
         <form id="ue-entity-form" onSubmit={handleSubmit(handleUpdateEntity)}>
            <div className={"form w-100"}>
               <div className="form-row">
                  <div className="col-12 m-0">
                     {/* <label
                                htmlFor="name"
                                className={"col-form-label ue-col-form-label"}
                            >
                                Nom de ma structure :
                            </label>
                            <input
                                type="text"
                                id="entity_name"
                                name="entity_name"
                                {...register("name")}
                                readOnly
                                onChange={debounce(submitAfterDebounce, 2000)}
                                defaultValue={entity.name ? entity.name : ""}
                                style={{
                                    padding: "8px",
                                    border: "none",
                                    backgroundColor: "#F9F9F9",
                                }}
                            /> */}
                     <div className="did-floating-label-content">
                        <input
                           className="did-floating-input"
                           type="text"
                           id={"entity_name"}
                           name={"entity_name"}
                           placeholder=" "
                           {...register("name")}
                           readOnly
                           onChange={debounce(submitAfterDebounce, 2000)}
                           defaultValue={entity.name ? entity.name : ""}
                        ></input>
                        <label className="did-floating-label">Nom de ma structure</label>
                     </div>
                     {errors.name && <span className={"text-danger mt-1"}>Ce champ est requis !</span>}
                  </div>
                  {/*<div className="form-group col-12 col-md-6">
                            <label htmlFor="entity_siren" className={"col-form-label ue-col-form-label"}>siren</label>
                            <input type="text" className="form-control ue-form-control" id="entity_siren"  name="entity_siren"
                                   {...register("siren")}
                                   readOnly
                                   onChange={debounce( submitAfterDebounce, 2000 )}
                                   defaultValue={(entity.siren)?entity.siren:''}/>
                        </div>*/}
                  <div className="col-12 m-0">
                     {/* <label
                                htmlFor="address"
                                className={"col-form-label ue-col-form-label"}
                            >
                                Adresse :
                            </label>
                            <input
                                type="text"
                                // className="form-control ue-form-control"
                                id="address"
                                name="address"
                                {...register("address")}
                                onChange={debounce(submitAfterDebounce, 2000)}
                                defaultValue={
                                    entity.address ? entity.address : ""
                                }
                                style={{
                                    padding: "8px",
                                    border: "none",
                                    backgroundColor: "#F9F9F9",
                                }}
                            /> */}
                     <div className="did-floating-label-content">
                        <input
                           className="did-floating-input"
                           type="text"
                           id={"adress"}
                           name={"adress"}
                           placeholder=" "
                           {...register("address")}
                           onChange={debounce(submitAfterDebounce, 2000)}
                           defaultValue={entity.address ? entity.address : ""}
                        ></input>
                        <label className="did-floating-label">Adresse</label>
                     </div>
                  </div>
               </div>
               <div className="form-row">
                  <div className="col-12 col-md-6 m-0">
                     {/* <label
                                htmlFor="cp"
                                className={"col-form-label ue-col-form-label"}
                            >
                                Code Postal :
                            </label>
                            <input
                                type="text"
                                id="entity_cp"
                                name="entity_cp"
                                {...register("cp")}
                                onChange={debounce(submitAfterDebounce, 2000)}
                                defaultValue={entity.cp ? entity.cp : ""}
                                style={{
                                    padding: "8px",
                                    border: "none",
                                    backgroundColor: "#F9F9F9",
                                }}
                            /> */}
                     <div className="did-floating-label-content">
                        <input
                           className="did-floating-input"
                           type="text"
                           id={"entity_cp"}
                           name={"entity_cp"}
                           placeholder=" "
                           {...register("cp")}
                           onChange={debounce(submitAfterDebounce, 2000)}
                           defaultValue={entity.cp ? entity.cp : ""}
                        ></input>
                        <label className="did-floating-label">Code Postal</label>
                     </div>
                  </div>
                  <div className="col-12 col-md-6 m-0">
                     {/* <label
                                htmlFor="entity_city"
                                className={
                                    "col-sm-3 col-form-label ue-col-form-label"
                                }
                            >
                                Ville :
                            </label>
                            <input
                                type="text"
                                id="entity_city"
                                name="entity_city"
                                {...register("city")}
                                onChange={debounce(submitAfterDebounce, 2000)}
                                defaultValue={entity.city ? entity.city : ""}
                                style={{
                                    padding: "8px",
                                    border: "none",
                                    backgroundColor: "#F9F9F9",
                                }}
                            /> */}
                     <div className="did-floating-label-content">
                        <input
                           className="did-floating-input"
                           type="text"
                           id={"entity_city"}
                           name={"entity_city"}
                           placeholder=" "
                           {...register("city")}
                           onChange={debounce(submitAfterDebounce, 2000)}
                           defaultValue={entity.city ? entity.city : ""}
                        ></input>
                        <label className="did-floating-label">Ville</label>
                     </div>
                  </div>
               </div>
               <div className="form-row">
                  <div className="col-12 col-md-6 m-0">
                     {/* <label
                                htmlFor="entity_phone"
                                className={"col-form-label ue-col-form-label"}
                            >
                                Tél. fixe :
                            </label>
                            <input
                                type="text"
                                id="entity_phone"
                                name="entity_phone"
                                pattern="[0-9]{10}"
                                {...register("phone")}
                                onChange={debounce(submitAfterDebounce, 2000)}
                                defaultValue={entity.phone ? entity.phone : ""}
                                style={{
                                    padding: "8px",
                                    border: "none",
                                    backgroundColor: "#F9F9F9",
                                }}
                            /> */}
                     <div className="did-floating-label-content">
                        <input
                           className="did-floating-input"
                           type="text"
                           id={"entity_phone"}
                           name={"entity_phone"}
                           placeholder=" "
                           pattern="[0-9]{10}"
                           {...register("phone")}
                           onChange={debounce(submitAfterDebounce, 2000)}
                           defaultValue={entity.phone ? entity.phone : ""}
                        ></input>
                        <label className="did-floating-label">Tél. fixe</label>
                     </div>
                  </div>
                  <div className="col-12 col-md-6 m-0">
                     {/* <label
                                htmlFor="entity_mobile"
                                className={"col-form-label ue-col-form-label"}
                            >
                                Tél. mobile :
                            </label>
                            <input
                                type="text"
                                id="entity_phone2"
                                name="entity_phone2"
                                pattern="[0-9]{10}"
                                {...register("phone2")}
                                onChange={debounce(submitAfterDebounce, 2000)}
                                defaultValue={
                                    entity.phone2 ? entity.phone2 : ""
                                }
                                style={{
                                    padding: "8px",
                                    border: "none",
                                    backgroundColor: "#F9F9F9",
                                }}
                            /> */}
                     <div className="did-floating-label-content">
                        <input
                           className="did-floating-input"
                           type="text"
                           id={"entity_phone2"}
                           name={"entity_phone2"}
                           placeholder=" "
                           pattern="[0-9]{10}"
                           {...register("phone2")}
                           onChange={debounce(submitAfterDebounce, 2000)}
                           defaultValue={entity.phone2 ? entity.phone2 : ""}
                        ></input>
                        <label className="did-floating-label">Tél. mobile</label>
                     </div>
                  </div>
               </div>
               <div className="form-row">
                  <div className="col-12 m-0">
                     {/* <label
                                htmlFor="entity_email"
                                className={"col-form-label ue-col-form-label"}
                            >
                                Email de contact :
                            </label>
                            <input
                                type="text"
                                id="entity_email"
                                name="entity_email"
                                {...register("email")}
                                onChange={debounce(submitAfterDebounce, 2000)}
                                defaultValue={entity.email ? entity.email : ""}
                                style={{
                                    padding: "8px",
                                    border: "none",
                                    backgroundColor: "#F9F9F9",
                                }}
                            /> */}
                     <div className="did-floating-label-content">
                        <input
                           className="did-floating-input"
                           type="text"
                           id={"entity_email"}
                           name={"entity_email"}
                           placeholder=" "
                           {...register("email")}
                           onChange={debounce(submitAfterDebounce, 2000)}
                           defaultValue={entity.email ? entity.email : ""}
                        ></input>
                        <label className="did-floating-label">Email de contact</label>
                     </div>
                  </div>
               </div>
               <button type={"submit"} id={"ue_entity_form_hidden_submit"} style={{ display: "none" }} />
            </div>
         </form>
      </div>
   );
};

const mapStateToProps = (state) => {
   return {
      userId: state.MeReducer.id,
      username: state.MeReducer.username,
      role: state.MeReducer.role,
      types: state.SubscribtionReducer.types,
      structureInfo: state.SubscribtionReducer.structureInfo,
      entity: state.MeReducer.entity,
   };
};

const mapDispatchTProps = (dispatch) => {
   return {
      updateStructureInfo: (e) => dispatch({ type: "UPDATE_STRUCTURE_INFO", data: e }),
      updateUserInfo: (e) => dispatch({ type: "UPDATE_USER_STATUS", data: e }),
   };
};

export default connect(mapStateToProps, mapDispatchTProps)(CompteEntityForm);
